module.exports = __webpack_public_path__ + "static/dustin-moskovitz-aba81f459b724b8145942fbc20a7ed0f.jpg";